module.exports = __webpack_public_path__ + "static/img/user3.bf89296.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/user3.png
// module id = TwwX
// module chunks = 0